module.exports = __webpack_public_path__ + "static/media/download.50a7e214.svg";